<template>
  <div>
    <v-list two-line subheader>
      <v-subheader inset>Associados ({{clients.length}})</v-subheader>

      <v-list-tile
        v-for="item in clients"
        :key="item.id"
        avatar
        @click.stop="openEditClientDialog(item)"
      >
        <v-list-tile-avatar>
          <v-icon
            v-if="!item.dependant"
            :color="item.active ? 'secondary' : 'blue-grey lighten-4'"
          >contact_mail</v-icon>
          <v-icon
            v-if="item.dependant"
            :color="item.active ? 'secondary' : 'blue-grey lighten-4'"
          >group</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>
            {{ item.name }}
            <span class="grey--text text--lighten-1">{{ item.clientId }}</span>
          </v-list-tile-title>

          <v-list-tile-sub-title>
            {{ item.documentType }} {{ item.documentNumber }}
            <template v-if="item.email">
              <span class="grey--text text--lighten-2">|</span>
              {{ item.email }}
            </template>
            <template v-if="item.phone">
              <span class="grey--text text--lighten-2">|</span>
              {{ item.phone }}
            </template>
          </v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action v-if="!item.dependant">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn icon ripple v-on="on" @click.stop="addDependant(item)">
                <v-icon color="grey lighten-1">group_add</v-icon>
              </v-btn>
            </template>
            <span>Adicionar dependente</span>
          </v-tooltip>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>

    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn fab bottom right color="#db1a83" dark fixed @click="openNewClientDialog" v-on="on">
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <span>Novo associado</span>
    </v-tooltip>

    <v-dialog v-model="dialog" width="800px" persistent>
      <v-card>
        <v-form ref="form" @submit.prevent="saveClient" lazy-validation>
          <v-card-title
            class="grey lighten-4 py-4 title"
          >Associado {{selectedClient.dependant ? 'dependente' : 'principal'}}</v-card-title>
          <v-container grid-list-sm class="pa-4">
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  prepend-icon="contact_mail"
                  placeholder="Número do associado"
                  v-model="selectedClient.clientId"
                  :rules="[rules.required,rules.number]"
                  autofocus
                  v-if="dialog"
                  :disabled="selectedClient.dependant || !!selectedClient.id"
                ></v-text-field>
              </v-flex>

              <v-flex xs6>
                <v-text-field
                  prepend-icon="today"
                  placeholder="Data de início (dd/mm/aaaa)"
                  v-model="selectedClient.initDate"
                  mask="##/##/####"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  prepend-icon="person"
                  placeholder="Nome"
                  v-model="selectedClient.name"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>

              <v-flex xs9>
                <v-text-field
                  prepend-icon="fingerprint"
                  placeholder="Número do documento"
                  v-model="selectedClient.documentNumber"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs2>
                <v-select
                  placeholder="Tipo"
                  v-model="selectedClient.documentType"
                  :rules="[rules.required]"
                  :items="['RG', 'RNE', 'PASSAPORTE']"
                ></v-select>
              </v-flex>

              <v-flex xs6>
                <v-text-field
                  prepend-icon="email"
                  placeholder="Email"
                  v-model="selectedClient.email"
                  :rules="[rules.email]"
                ></v-text-field>
              </v-flex>

              <v-flex xs6>
                <v-text-field
                  prepend-icon="phone"
                  placeholder="Número de telefone"
                  v-model="selectedClient.phone"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-switch
                  :label="((selectedClient.active) ? 'Ativo' : 'Inativo') + (selectedClient.dependant ? ' (modificar no associado principal)' : '' )"
                  v-model="selectedClient.active"
                  :disabled="selectedClient.dependant"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-btn
              flat
              color="red"
              @click="deleteClient"
              v-if="selectedClient.id"
              :loading="deleting"
            >Remover</v-btn>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="dialog = false">Cancelar</v-btn>
            <v-btn color="primary" type="submit" :loading="saving">Salvar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import db from "@/services/database";

export default {
  data: () => {
    return {
      dialog: false,
      saving: false,
      deleting: false,
      selectedClient: newEmptyClient(),
      clients: [],
      rules: {
        required: v => !!v || "requerido",
        email: v =>
          /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/.test(v) ||
          v == "" ||
          "email inválido",
        number: v => /^\d+$/.test(v) || v == "" || "número inválido"
      }
    };
  },
  created() {
    db.collection("clients")
      .orderBy("clientId")
      .orderBy("dependant")
      .onSnapshot(snapshot => {
        let items = [];
        snapshot.forEach(doc => {
          items.push(buildClient(doc));
        });
        this.clients = items;
      });
  },

  methods: {
    openNewClientDialog: function() {
      this.selectedClient = newEmptyClient();
      this.$refs.form.resetValidation();
      this.dialog = true;
    },
    addDependant: function(item) {
      this.selectedClient = newEmptyClient();
      this.selectedClient.dependant = true;
      this.selectedClient.active = item.active;
      this.selectedClient.clientId = item.clientId;
      this.$refs.form.resetValidation();
      this.dialog = true;
    },
    openEditClientDialog: function(item) {
      this.selectedClient = { ...item };
      this.$refs.form.resetValidation();
      this.dialog = true;
    },
    deleteClient: async function() {
      if (!confirm("¿Você tem certeza?")) {
        return;
      }
      try {
        this.deleting = true;
        if (!this.selectedClient.dependant) {
          let docs = await db
            .collection("clients")
            .where("clientId", "==", this.selectedClient.clientId)
            .where("dependant", "==", true)
            .get();

          if (docs.size > 0) {
            throw "Primero borrar todos los dependientes";
          }
        }

        await db
          .collection("clients")
          .doc(this.selectedClient.id)
          .delete();
        this.dialog = false;
      } catch (error) {
        alert(error);
      } finally {
        this.deleting = false;
      }
    },
    saveClient: async function() {
      if (!this.$refs.form.validate()) {
        return;
      }

      // - si ya existe el clientId tiene que ser un dependentiente
      // - si es dependiente, tiene que ya existir un clientId principal

      try {
        this.saving = true;

        if (this.selectedClient.id) {
          // update client

          let res = await db
            .collection("clients")
            .where("documentNumber", "==", this.selectedClient.documentNumber)
            .get();
          if (res.size > 0) {
            if (res.docs.some(doc => doc.id != this.selectedClient.id)) {
              throw "documento duplicado";
            }
          }

          await db
            .collection("clients")
            .doc(this.selectedClient.id)
            .update({
              name: this.selectedClient.name,
              email: this.selectedClient.email.toLowerCase() || "",
              documentType: this.selectedClient.documentType,
              documentNumber: this.selectedClient.documentNumber,
              phone: this.selectedClient.phone,
              initDate: this.selectedClient.initDate,
              active: this.selectedClient.active
            });

          if (!this.selectedClient.dependant) {
            //update active state on all dependants

            let res = await db
              .collection("clients")
              .where("clientId", "==", this.selectedClient.clientId)
              .where("dependant", "==", true)
              .get();

            res.docs.forEach(async doc => {
              await db
                .collection("clients")
                .doc(doc.id)
                .update({
                  active: this.selectedClient.active
                });
            });
          }
        } else {
          // create client

          /*
        await firebase.auth().sendSignInLinkToEmail(this.newPartner.email, {
          url: "https://saude-plus.firebaseapp.com/complete-sign-in",
          handleCodeInApp: true
        });
        */

          let res = await db
            .collection("clients")
            .where("documentNumber", "==", this.selectedClient.documentNumber)
            .get();
          if (res.size > 0) {
            throw "documento duplicado";
          }

          if (!this.selectedClient.dependant) {
            res = await db
              .collection("clients")
              .where("clientId", "==", this.selectedClient.clientId)
              .get();
            if (res.size > 0) {
              throw "número do associado duplicado";
            }
          }

          // await db.collection("users").add({
          //   email: this.newClient.email,
          //   role: "client"
          // });

          await db.collection("clients").add({
            clientId: this.selectedClient.clientId,
            name: this.selectedClient.name,
            email: this.selectedClient.email.toLowerCase() || "",
            documentType: this.selectedClient.documentType,
            documentNumber: this.selectedClient.documentNumber,
            phone: this.selectedClient.phone,
            initDate: this.selectedClient.initDate,
            dependant: this.selectedClient.dependant,
            active: this.selectedClient.active
          });
        }

        this.dialog = false;
      } catch (err) {
        alert(err);
      } finally {
        this.saving = false;
      }
    }
  }
};

function buildClient(doc) {
  return {
    id: doc.id,
    clientId: doc.data().clientId || "0",
    name: doc.data().name,
    documentType: doc.data().documentType || "",
    documentNumber: doc.data().documentNumber || "",
    email: doc.data().email || "",
    phone: doc.data().phone || "",
    initDate: doc.data().initDate || null,
    dependant: doc.data().dependant || false,
    active: doc.data().active
  };
}

function newEmptyClient() {
  let today = new Date();
  let day = ("0" + today.getDate()).slice(-2);
  let month = ("0" + (today.getMonth() + 1)).slice(-2);

  let todayString = `${day}/${month}/${today.getFullYear()}`;
  console.log(todayString);
  return {
    clientId: "",
    name: "",
    email: "",
    documentType: "",
    documentNumber: "",
    phone: "",
    initDate: todayString,
    active: true,
    dependant: false
  };
}
</script>
